<div class="content-wrapper">
  <section class="white email-verified-section">
    <div class="email-verified-content-wrapper">
      <p class="pre-title" *ngIf="success">{{ pageData.pre_heading }}</p>

      <h1 class="email-verified-title" *ngIf="success">
        {{ pageData.heading }}
      </h1>

      <h1 class="email-verified-title" *ngIf="!success">
        {{ pageData.error_heading }}
      </h1>

      <ng-container *ngIf="success; else failure">
        <p>{{ pageData.success_message }}</p>
        <a routerLink="/">
          <button class="button login-button">
            {{ pageData.button_text }}
          </button>
        </a>
      </ng-container>

      <ng-template #failure>
        <ng-container [ngSwitch]="failureReason">
          <!-- Account not found -->
          <p *ngSwitchCase="'account-not-found'">
            {{ pageData.not_found_message }}
          </p>
          <!-- Verification link expired -->
          <ng-container *ngSwitchCase="'expired'">
            <p>
              {{ pageData.expired_message }}
            </p>
            <button
              class="resend-button"
              *ngIf="email && !(resent || resendError)"
              (click)="resendEmail($event)"
            >
              {{ pageData.resend_button_text }}
            </button>
          </ng-container>
          <!-- Invalid token provided -->
          <ng-container *ngSwitchCase="'invalid'">
            <p>
              {{ pageData.invalid_message }}
            </p>
            <button
              class="resend-button"
              *ngIf="email && !(resent || resendError)"
              (click)="resendEmail($event)"
            >
              {{ pageData.resend_button_text }}
            </button>
          </ng-container>
          <!-- Used token provided -->
          <p *ngSwitchCase="'used'">
            {{ pageData.used_message }}
          </p>
        </ng-container>
      </ng-template>

      <div class="resent" *ngIf="resent">{{ pageData.resent_message }}</div>

      <div class="resend-error" *ngIf="resendError && !notFoundError">
        {{ pageData.resent_message }}
      </div>

      <div class="resend-error" *ngIf="resendError && notFoundError">
        {{ pageData.not_found_message }}
      </div>
    </div>
  </section>
  <ng-container *ngIf="pageData.image?.data?.attributes?.url">
    <div class="image-wrapper">
      <img
        class="email-verified-image"
        [src]="pageData.image?.data?.attributes?.url"
        alt=""
      />
    </div>
  </ng-container>
</div>
